import React from 'react';

import RowTable from '@elements/RowTable';

type BodyTableProps = {
  isHeader?: boolean,
  rowsContent: string[],
  tid: string,
};

const BodyTable = ({ 
  isHeader,
  rowsContent,
  tid,
}: BodyTableProps): JSX.Element => {
  const JSXTag = isHeader ? 'thead' : 'tbody';

  if (!rowsContent?.length) {
    return null;
  }

  return(
    <JSXTag>
      {rowsContent?.map((row, index) => {
        const rowId = `${ isHeader ? 'header' : 'body' }-row-${tid}-${index}`
        const toolTipText = row[5];
        return (
          <RowTable
            key={rowId}
            isHeader={isHeader}
            rowContent={row}
            rowId={rowId}
            toolTipText={toolTipText}
          />
        )
      })}
    </JSXTag>
  )
}

export default BodyTable;
